import React from 'react';
import { withRouter } from 'react-router-dom';
import { RoutedTabs, NavTab } from 'react-router-tabs';
import './styles.css';
import PropTypes from 'prop-types';

const ReviewHeaderNavGuest = props => {
  const { tabs, pageUrl } = props;
  return (
    <RoutedTabs
      className="review-header-nav-guest__navtabs"
      startPathWith={pageUrl}
      tabClassName="review-header-nav-guest__navtab"
      activeTabClassName="review-header-nav-guest__navtab--selected"
    >
      <NavTab exact to="">
        Overview
      </NavTab>
      {/*{tabs.about && <NavTab to="/about">About</NavTab>}*/}
      {tabs.about && (
        <a className={'review-header-nav-guest__navtab'} href="/signup">
          About
        </a>
      )}
      {tabs.review && <NavTab to="/reviews">Reviews</NavTab>}
      {/*{tabs.compensation && (*/}
      {/*<NavTab to="/compensation">Compensation</NavTab>*/}
      {/*)}*/}
      {tabs.compensation && (
        <a className={'review-header-nav-guest__navtab'} href="/signup">
          Compensation
        </a>
      )}
      {tabs.portfolio && <NavTab to="/portfolio">Portfolio</NavTab>}
      {/*{tabs.fundraising && <NavTab to="/fundraising">Fundraising</NavTab>}*/}
      {tabs.about && (
        <a className={'review-header-nav-guest__navtab'} href="/signup">
          Fundraising
        </a>
      )}
    </RoutedTabs>
  );
};

ReviewHeaderNavGuest.propTypes = {
  tabs: PropTypes.shape({
    about: PropTypes.bool.isRequired,
    review: PropTypes.bool.isRequired,
    compensation: PropTypes.bool.isRequired,
    fundraising: PropTypes.bool.isRequired,
    portfolio: PropTypes.bool.isRequired,
  }),
};

export default withRouter(ReviewHeaderNavGuest);
